import React from "react";
import { RepaymentTemplate } from "../../Templates/RepaymentTemplate";

export const Repayment = () => {
  return <RepaymentTemplate />;
};
